import {useState} from 'react';
import {useTranslation} from 'react-i18next';
import ModalPortal from 'src/components/layout/modal/ModalPortal';
import {PolicyLinks} from 'src/components/policy/links/PolicyLinks';
import {useLocationDetailsContext} from 'src/context/LocationDetailsContext';
import {getCaregiverCookiePolicyLink} from 'src/services/api/api';

export function LocationFooter() {
    const {t} = useTranslation();

    const {
        locationDataState: {loading, caregiver, location}
    } = useLocationDetailsContext();
    const [showTermsModal, setShowTermsModal] = useState(false);

    const caregiverPolicyLink = getCaregiverCookiePolicyLink(caregiver?.id as number);

    return (
        <footer className='container__footer'>
            {!loading && caregiverPolicyLink && showTermsModal && (
                <ModalPortal onCloseClick={() => setShowTermsModal(false)}>
                    <div className='policy-modal'>
                        <h1 className='policy-modal__header'>{t('confirm.policy.header')}</h1>
                        <p className='policy-modal__content wrap-html'>{caregiverPolicyLink}</p>
                    </div>
                </ModalPortal>
            )}
            <div>
                <a href={process.env.REACT_APP_LANDING_PAGE_URL} target='_blank' rel='noreferrer'>
                    <img src='/mittvaccin_logo.svg' alt='MittVaccin Logo' />
                    <span className='screen-reader-only'>{t('general.opens_in_new_window')}</span>
                </a>
            </div>

            <div className='container__footer__links'>
                <p>
                    <PolicyLinks />
                    {location && (
                        <a
                            href='/'
                            onClick={(e) => {
                                e.preventDefault();
                                setShowTermsModal(true);
                            }}
                        >
                            {t('clinic_footer.clinic_privacy_policy')}
                        </a>
                    )}
                </p>
            </div>
        </footer>
    );
}
